import { isContainerBlock, TBlock } from '@wp-block-builder/package';
import AddMenuButton from '@wp-block-builder/views/EditableMessage/components/AddBlockButton/blocks/Container';

import { TFlatBlock } from './blocksToFlatDocument';

type TTreeNode = {
  block: TBlock;
  children: TTreeNode[];
};

export default function blocksFromFlatDocument(flatTree: TFlatBlock[]): TBlock[] {
  const result: TTreeNode[] = [];

  let currentParentNodes: TTreeNode[] = [];
  for (const fBlock of flatTree) {
    if (fBlock.depth === 0) {
      const n: TTreeNode = { block: fBlock.block, children: [] };
      currentParentNodes = [n];
      result.push(n);
    } else {
      const parent = currentParentNodes[fBlock.depth - 1];
      const n: TTreeNode = { block: fBlock.block, children: [] };
      currentParentNodes = [...currentParentNodes.slice(0, fBlock.depth), n];
      parent.children.push(n);
    }
  }
  return result.map(processTreeNode);
}

function processTreeNode(node: TTreeNode): TBlock {
  if (!isContainerBlock(node.block)) {
    if (node.children.length === 0) {
      return node.block;
    }
    throw new Error('Attempted to add children to a non container block');
  }

  const result = {
    ...node.block,
    props: {
      ...node.block.props,
      blocks: node.children.map(processTreeNode),
    },
  };

  if (result.type === 'ColumnsSection') {
    result.props.blocks = getColumnsBlocks(result.props.blocks);
  }
  return result;
}

function getColumnsBlocks(blocks: TBlock[]) {
  while (blocks.length < 3) {
    blocks.push(AddMenuButton.defaultColumnBlock());
  }
  return blocks;
}
